"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GlobalCss = require("./GlobalCss");

Object.keys(_GlobalCss).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GlobalCss[key];
    }
  });
});